<template>
    <!-- 图文内容可编辑区域[[ -->
    <div>
        <div class="edit-content img-content">
            <div class="title">
                <input type="text" class="title-textarea" rows="1" maxlength="30" placeholder="请输入标题内容（30个字以内）" v-model="params.title" @blur="validateParam('title')">
                <span class="wordsNum"><em class="wordsNum-dynamic">{{params.title.length | 0}}</em>/<em class="wordsNum-fixed">30</em></span>
                <!-- 错误提示 -->
                <p class="error-prompt" v-if="errorTips.title">未输入标题</p>
            </div>
            <tgl-richeditor :id="richOptions.id" :buttons="richOptions.buttons" :height="richOptions.height" ref="richeditor">
            </tgl-richeditor>
        </div>
    </div>

    <!-- 图文内容可编辑区域]] -->
</template>
<style  lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/contribution.scss";
@import "~Assets/sass/pages/v4/order/order_contribute.scss";
#tgl-rich__editor {
    font-size: 14px;
    /deep/ .tig-editor-wrapper {
        border-bottom-color: #ebebeb;
    }
    /deep/ .editor-toolbar {
        border-bottom-color: #ebebeb;
    }
    /deep/ .tig-btn {
        display: inline-block;
        margin-right: 5px;
    }
    /deep/ input[type="submit"] {
        width: 72px;
        line-height: 25px;
        height: 25px;
        box-sizing: border-box;
    }
    /deep/ .controls {
        margin-bottom: 5px;
    }
    /deep/ #upload-image-pannel {
        .control-label {
            display: inline-block;
        }
        .controls {
            margin-left: 0;
            display: inline-block;
            margin-bottom: 15px;
        }
    }
}
</style>
<script>
export default {
    name: 'person_content_create.vue',
    data() {
        return {
            params: {
                title: '',
                content: ''// 内容详情
            },
            dialog: {
                showTag: false
            },
            errorTips: {
                title: false
            },
            richOptions: {
                id: 'rich',
                buttons: [
                    'h1', 'bold', 'italic', 'underline', 'blockquote', 'hr', '|',
                    'font', 'size', 'color', '|',
                    'insertorderedlist', 'insertunorderedlist', 'justify', '|',
                    'link', 'table', 'image', 'video', '|',
                    'removeFormat', 'undo', 'redo', '|',
                    'fullscreen'
                ],
                height: 320
            }
        }
    },
    components: {},
    created() {

    },
    mounted() {

    },
    methods: {
        validateParam(tip) {
            if (tip == 'title') {
                if (this.params.title.length == 0) {
                    this.errorTips.title = true;
                } else {
                    this.errorTips.title = false;
                }
            }
        },
        getContentLength() {
            let content = this.$refs.richeditor.getHtml();
            return content.length;
        },
        getParams() {
            let content = this.$refs.richeditor.getHtml();
            this.params.content = content;
            return {
                content: content
            };
        },
        fillForm(data) {
            let {
                articleTitle, articleContent
            } = data;
            this.params.title = articleTitle;
            this.$refs.richeditor.setHtml(articleContent)
        }
    },
    watch: {
        "params.title": function () {
            this.$emit('update:title', this.params.title);
        }
    }
}
</script>
